<h1 translate
    matDialogTitle>
    alerts_details_modal_title
</h1>
<mat-dialog-content class="alert-detail-modal">
    <ul class="no-bullets">
        <li *ngIf="context.data.Message">
            <strong translate>alerts_details_modal_message</strong>: {{context.data.Message}}</li>
        <li *ngIf="context.data.RobotName">
            <strong translate>alerts_details_modal_robot_name</strong>: {{context.data.RobotName}}</li>
        <li *ngIf="context.data.ProcessName">
            <strong translate>alerts_details_modal_process_name</strong>: {{context.data.ProcessName}}</li>
    </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button
            mat-dialog-close
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
